import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getAvslutningDialerByAfid } from 'actions'
import {isEmpty} from 'lodash'
import {Grid} from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';
function mapStateToProps({auth,DashBoard}) {
    const { authUser} = auth;
    const { Hitrate,DashboardDialerFilterOption} = DashBoard;
    return {
        authUser,Hitrate,DashboardDialerFilterOption
    };
}
function mapDispatchToProps(dispatch) {
    return {
        getAvslutningDialerByAfid: (Afid,userid,FilterOption) => dispatch(getAvslutningDialerByAfid(Afid,userid,FilterOption)),
        dispatch
    }
}
class Avslutning extends Component {
    state={
        Hitrate:0,
        DashboardDialerFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getAvslutningDialerByAfid(Afid,undefined,this.state.DashboardDialerFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })          
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getAvslutningDialerByAfid(Afid,undefined,this.state.DashboardDialerFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            30000
        );
      }
    componentDidUpdate=()=>{
      /*  if(this.props.DashboardDialerFilterOption !== this.state.DashboardDialerFilterOption && !isEmpty(this.props.DashboardDialerFilterOption))
           {
                
               const Afid = this.props.Afid;
               this.props.getAvslutningDialerByAfid(Afid).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) 
               this.setState({
                DashboardDialerFilterOption:this.props.DashboardDialerFilterOption 
               }) 
           }
           */
        }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }
    formatNumber=(number)=>{
        console.log('test2652455112', 'det är 100', number)
        if(number > 1000000){
            return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
        }else if(number >= 1000){
            return `${(number/1000).toFixed(0)}K`
        }else if(number >= 100){
            // return number
            // console.log('test26524555', 'det är 100', number)
            return Math.round(number)
        }else{
            return Number(number).toFixed(1)
        }
    }
    render() {
        return (
            <div className="text-center h-100" style={{ color: 'white' }}>
            <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            className='h-100'
            >
                <Grid item style={{width: "155px"}}>
                <h2 style={{
                    //fontWeight: 100,
                    fontSize: "14px",margin: "5px",fontWeight:"300",textAlign: "left",
                marginLeft: "10px"}}><b><IntlMessages id="DashBoard.Hitrate"/></b></h2>
                </Grid>
                <Grid item>
                {
                    this.state.done === false?
                    <Skeleton variant="rectangular" height={60} width={'100px'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                    :
                <h2 className="display-4" 
                style={{ fontSize: 22,  margin: 'auto 7px',fontWeight:"500", marginTop: '7px' }}>
                    {this.formatNumber(this.props.Hitrate)}%
                    <small style={{fontSize:12, fontWeight: '300'}}>/<IntlMessages id="Month.Short1"/></small>
                </h2>
                }
                </Grid>
            </Grid>
        </div>
        ) 
    }
}
export default connect(
    mapStateToProps,mapDispatchToProps
)(Avslutning);

